import { FC } from 'react';

import { Modal, ModalOverlay } from '@bonusly/design-system';

import { ReactionModalContent } from './reaction-modal-content';

interface ReactionModalProps {
	isOpen: boolean;
	onClose: VoidFunction;
}

export const ReactionModal: FC<ReactionModalProps> = ({ isOpen, onClose }) => {
	return (
		<Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered scrollBehavior="inside">
			<ModalOverlay />
			<ReactionModalContent />
		</Modal>
	);
};
